/** Public deployment destinations. Update these defaults together when moving domains. */
export const defaultSiteUrls = {
  marketing: 'https://callsyncapp.com',
  dashboard: 'https://dash.callsyncapp.com',
  help: 'https://help.callsyncapp.com',
};
export type SiteUrls = typeof defaultSiteUrls;
export function resolveSiteUrls(overrides: Partial<SiteUrls> = {}): SiteUrls {
  return Object.fromEntries(Object.entries(defaultSiteUrls).map(([key, fallback]) => {
    const raw = overrides[key as keyof SiteUrls] || fallback;
    const url = new URL(raw);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.search || url.hash || url.pathname !== '/') {
      throw new Error(`Invalid ${key} site origin`);
    }
    return [key, url.origin];
  })) as SiteUrls;
}
/** Keep page paths, query strings and fragments when moving between configured hosts. */
export function siteLink(value: string, urls: SiteUrls): string {
  if (!/^https?:\/\//i.test(value)) return value;
  const url = new URL(value);
  const known: Record<string, keyof SiteUrls> = {
    'https://callsyncapp.com': 'marketing',
    'https://www.callsyncapp.com': 'marketing',
    'https://callsync-try4-website.pages.dev': 'marketing',
    'https://dash.callsyncapp.com': 'dashboard',
    'https://callsync-dashboard-try4.pages.dev': 'dashboard',
    'https://help.callsyncapp.com': 'help',
    'https://callsync-help-center.pages.dev': 'help',
  };
  const role = known[url.origin];
  return role ? `${urls[role]}${url.pathname}${url.search}${url.hash}` : value;
}
export function siteHtml(html: string, urls: SiteUrls): string {
  return html.replace(/\bhref=(["'])(https?:\/\/[^"']+)\1/gi, (_, quote, url) => `href=${quote}${siteLink(url, urls)}${quote}`);
}
export function siteRedirects(text: string, urls: SiteUrls): string {
  return text.split('\n').map(line => {
    if (!line.trim() || line.trimStart().startsWith('#')) return line;
    const parts = line.trim().split(/\s+/);
    parts[1] = siteLink(parts[1], urls);
    return parts.join(' ');
  }).join('\n');
}
